import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DesignationCandidateModal from './DesignationCandidateModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesignatePrimaryContactModal',
    props: /*@__PURE__*/ _mergeModels({
        members: {},
        submitting: { type: Boolean, default: false },
        serverError: { default: null },
        backLabelKey: { default: 'back' }
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["back", "confirm"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        /**
         * "Désigner un nouveau contact principal" modal (OP-5804 / US-04c, shared with US-04d/04e).
         *
         * Shown when the primary owner of a shared email is about to leave the group (value change,
         * email deletion, contact deletion) and 2+ members would remain: OPHUB then requires a
         * `newPrimaryChannelId` on the SAME write call (409 `TransferRequired` otherwise). The user
         * picks the new primary among the remaining members; "Confirmer et finaliser" hands the
         * selected channel id back to the owner of the pending write.
         *
         * Thin wrapper over DesignationCandidateModal (single owner of the chrome, shared with the
         * household designation flow — OP-7428 review): this file only resolves the shared-email i18n
         * namespace and maps SharedEmailGroupMember onto {id: channelId, name}. The back button's label
         * is caller-supplied via `backLabelKey` because its meaning differs per flow: the EDIT flow
         * returns to the still-mounted edit modal ("Retour à la modification"), whereas the DELETE flow
         * simply abandons the deletion ("Annuler"). Built from interim mockups (no Figma yet) —
         * reconcile against Figma when it lands.
         */
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        const { t } = useI18n();
        const tk = (key) => t(`contact.detail.designatePrimary.${key}`);
        const items = computed(() => props.members.map((m) => ({ id: m.channelId, name: m.contactName })));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DesignationCandidateModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                items: items.value,
                icon: "ri-user-shared-line",
                title: tk('title'),
                subtitle: tk('subtitle'),
                "mandatory-heading": tk('mandatory'),
                "choose-label": tk('chooseLabel'),
                "item-sublabel": tk('currentlySecondary'),
                "selected-badge-label": tk('willBecomePrimary'),
                "confirm-label": tk('confirm'),
                "back-label": tk(__props.backLabelKey),
                "unknown-item-label": tk('unknownContact'),
                "testid-prefix": "designate-primary",
                submitting: __props.submitting,
                "server-error": __props.serverError,
                onBack: _cache[1] || (_cache[1] = ($event) => (emit('back'))),
                onConfirm: _cache[2] || (_cache[2] = ($event) => (emit('confirm', $event)))
            }, null, 8 /* PROPS */, ["modelValue", "items", "title", "subtitle", "mandatory-heading", "choose-label", "item-sublabel", "selected-badge-label", "confirm-label", "back-label", "unknown-item-label", "submitting", "server-error"]));
        };
    }
});
